export default function Footer(){  
    return (
        <footer className="footer">
            <div className="container">
                <p>&copy; 2024 Manikandan's Portfolio. All rights reserved.</p>
            </div>
        </footer>
    );
}